import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "content-block chat-messages" }
const _hoisted_2 = { class: "chat-messages__container" }
const _hoisted_3 = {
  key: 0,
  class: "chat-messages__container-divider"
}

import { computed } from "vue";
import {
	ChatModes,
	Dialog
} from "@/store/chats";
import { headerStore } from "@/store/header";
import ChatDialog from "@/components/main/chat-panel/ChatDialog.vue";
import AppLoader from "@/components/common/AppLoader.vue";


type ChatMessagesPanelProps = {
	loading: boolean;
	dialogs: Dialog[],
	mode: ChatModes
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderChatDialogsPanel',
  props: {
    loading: { type: Boolean },
    dialogs: {},
    mode: {}
  },
  emits: ["on-open", "on-delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const store = headerStore()
const emit = __emit

const isLoading = computed(() => store.loadingDialogs)

const onOpenDialog = (dialog: Dialog) => emit("on-open", dialog)
const onDeleteDialog = (dialogId: number) => emit("on-delete", dialogId)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isLoading.value && !props.dialogs.length)
        ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dialogs, (dialog, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: dialog.Id
        }, [
          _createVNode(ChatDialog, {
            dialog: dialog,
            onOnOpen: onOpenDialog,
            onOnDelete: onDeleteDialog
          }, null, 8, ["dialog"]),
          (index < _ctx.dialogs.length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ]))
}
}

})